import React from 'react';

function ClientsBenefitsIcon6() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        fill="#1B1F2C"
        d="M26.623 15.961l2.465 2.411c.357.333.476.75.357 1.25-.143.488-.453.792-.929.91l-3.357.858.947 3.321c.142.489.03.905-.34 1.25-.345.37-.762.483-1.25.34l-3.321-.947-.857 3.357c-.12.477-.423.786-.911.929a2.188 2.188 0 01-.34.036c-.368 0-.672-.131-.91-.393l-2.41-2.465-2.412 2.465c-.333.357-.75.476-1.25.357-.488-.131-.791-.44-.91-.929l-.857-3.357-3.322.947c-.488.143-.905.03-1.25-.34-.369-.345-.482-.761-.34-1.25l.947-3.321-3.357-.857c-.476-.12-.786-.423-.928-.91-.12-.5 0-.918.357-1.25l2.464-2.412-2.464-2.41c-.357-.334-.476-.75-.357-1.25.142-.489.452-.792.928-.911l3.357-.857-.946-3.322c-.143-.488-.03-.904.34-1.25.344-.369.761-.482 1.25-.339l3.32.947.858-3.358c.119-.488.422-.791.91-.91.489-.143.905-.03 1.25.339l2.411 2.482 2.41-2.482c.346-.357.763-.47 1.25-.34.489.12.793.423.912.911l.857 3.358 3.321-.947c.488-.143.905-.03 1.25.34.37.345.482.761.34 1.25l-.947 3.32 3.357.858c.476.119.786.422.929.91.119.5 0 .917-.357 1.25l-2.465 2.411z"
      />
    </svg>
  );
}

export default ClientsBenefitsIcon6;
